import * as React from "react";

import { Fab, Stack, Tooltip } from "@mui/material";
import {
  AddRounded,
  ContentCopyOutlined,
  LayersOutlined,
} from "@mui/icons-material";
import { TUseXElement } from "../../../hooks/useXElement";
import {
  COMPONENT_CHILDREN,
  UN_DELETABLE_COMPONENT,
} from "../../../utils/constants/gui/componentChildren";
import {
  MAIN_COLOR,
  GREEN_COLOR,
  YELLOW_COLOR,
} from "../../../utils/constants/common/utils";
import { isCommon } from "../../../hooks/useXCommon";
import { useCloneElement } from "../../../hooks/useCloneElement";
import { X_PAGE_SETTINGS } from "./XGUIHeader";
import { XGUIActionDeleteButton } from "./XGUIActionDeleteButton";

const AddElementDialog = React.lazy(() => import("../../AddElementDialog"));

type TDefaultXGUIAction = {
  color: string;
  title: string;
  icon: React.ReactElement;
  visible?: boolean;
  func?: (args?: any) => Promise<any> | any;
};

type TOverrideXGUIAction = {
  visible?: boolean;
  overrideComponent: React.ReactElement;
};

type TXGUIAction = TDefaultXGUIAction | TOverrideXGUIAction;

export const XGUIActions: React.FC<{
  selectedElement?: TUseXElement<any>;
  setSelectedIndex: (id: null | string) => void;
}> = ({ selectedElement = X_PAGE_SETTINGS, setSelectedIndex }) => {
  const cloneElement = useCloneElement();

  const [status, setStatus] = React.useState<{ open: boolean; self: boolean }>({
    open: false,
    self: false,
  });

  const close = (open: boolean) => setStatus({ open, self: false });

  const XGUI_ACTIONS: TXGUIAction[] = [
    {
      color: GREEN_COLOR,
      icon: <AddRounded sx={{ color: "white" }} />,
      title: "Ajouter un Enfant",
      visible:
        selectedElement.name !== "XPage" &&
        selectedElement.hasChildren &&
        !!COMPONENT_CHILDREN[selectedElement.name],
      func: () => setStatus({ open: true, self: false }),
    },
    {
      color: MAIN_COLOR,
      icon: <ContentCopyOutlined sx={{ color: "white" }} />,
      title: "Dupliquer cet Element",
      visible:
        selectedElement.name !== "XPage" &&
        !isCommon(selectedElement.index, true),
      func: cloneElement,
    },
    {
      color: YELLOW_COLOR,
      icon: <LayersOutlined sx={{ color: "white" }} />,
      title: "Changer de Template",
      visible: selectedElement.name !== "XPage",
      func: () => setStatus({ open: true, self: true }),
    },
    {
      overrideComponent: (
        <XGUIActionDeleteButton
          selectedElement={selectedElement}
          setSelectedIndex={setSelectedIndex}
        />
      ),
      visible:
        selectedElement.name !== "XPage" &&
        !UN_DELETABLE_COMPONENT.includes(selectedElement.name),
    },
  ];

  return (
    <Stack
      direction="row"
      position="relative"
      top={40}
      left={-2}

      // className="XGUI-Actions"
      // position="absolute"
      // right={-55}
      // top={0}
      // spacing="10px"
    >
      {XGUI_ACTIONS.filter((action) => action.visible !== false).map(
        (action, i) => {
          const _overrideAction = action as TOverrideXGUIAction;

          if (_overrideAction.overrideComponent) {
            return (
              <React.Fragment key={i.toString()}>
                {_overrideAction.overrideComponent}
              </React.Fragment>
            );
          }

          const _defaultAction = action as TDefaultXGUIAction;

          return (
            <Tooltip
              key={_defaultAction.title}
              title={_defaultAction.title}
              placement="bottom"
            >
              <Fab
                color="secondary"
                size="small"
                sx={{
                  pointerEvents: "all",
                  borderRadius: 0,
                  boxShadow: "none", // "0 5px 10px -5px rgba(0, 0, 0, 0.25)",
                  // bgcolor: _defaultAction.color,

                  // "&:hover": {
                  //   bgcolor: () => darken(_defaultAction.color, 0.2),
                  // },
                }}
                onClick={_defaultAction.func}
              >
                {_defaultAction.icon}
              </Fab>
            </Tooltip>
          );
        }
      )}

      {status.open && (
        <React.Suspense>
          <AddElementDialog setOpen={close} isSelf={status.self} />
        </React.Suspense>
      )}
    </Stack>
  );
};
